/**
 * EmailInstructions Component - Minimalist Design
 * Clean and focused email verification instructions
 */

import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope, faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';

interface EmailInstructionsProps {
  email: string;
}

export const EmailInstructions: React.FC<EmailInstructionsProps> = ({ email }) => {
  return (
    <div className="space-y-5">
      {/* Minimalist Header */}
      <div className="text-center">
        <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-3">
          <FontAwesomeIcon icon={faEnvelope} className="w-6 h-6 text-blue-600" />
        </div>
        
        <h1 className="text-xl font-semibold text-gray-900 mb-2">
          Cek Email Anda
        </h1>
        
        <p className="text-sm text-gray-600 mb-3">
          Kami telah mengirim link konfirmasi ke:
        </p>
        
        <div className="p-2.5 bg-gray-50 rounded-xl">
          <p className="text-sm font-medium text-gray-900 break-all">
            {email}
          </p>
        </div>
      </div>

      {/* Simplified Instructions */}
      <div className="space-y-3">
        <div className="flex items-center gap-3">
          <div className="w-5 h-5 bg-blue-100 rounded-full flex items-center justify-center flex-shrink-0">
            <span className="text-xs font-semibold text-blue-600">1</span>
          </div>
          <p className="text-sm text-gray-700">Buka aplikasi email Anda</p>
        </div>

        <div className="flex items-center gap-3">
          <div className="w-5 h-5 bg-blue-100 rounded-full flex items-center justify-center flex-shrink-0">
            <span className="text-xs font-semibold text-blue-600">2</span>
          </div>
          <p className="text-sm text-gray-700">Cari email dari Canvango</p>
        </div>

        <div className="flex items-center gap-3">
          <div className="w-5 h-5 bg-blue-100 rounded-full flex items-center justify-center flex-shrink-0">
            <span className="text-xs font-semibold text-blue-600">3</span>
          </div>
          <p className="text-sm text-gray-700">Klik link "Konfirmasi Email"</p>
        </div>
      </div>

      {/* Compact Warning */}
      <div className="flex items-center gap-2 p-2.5 bg-yellow-50 border border-yellow-200 rounded-xl">
        <FontAwesomeIcon icon={faExclamationTriangle} className="w-4 h-4 text-yellow-600 flex-shrink-0" />
        <p className="text-xs text-yellow-800">
          Tidak menemukan email? Cek folder <strong>Spam</strong> atau <strong>Junk</strong>
        </p>
      </div>
    </div>
  );
};